import { render, staticRenderFns } from "./ReplenishmentSimulator.vue?vue&type=template&id=3b87beae"
import script from "./ReplenishmentSimulator.vue?vue&type=script&lang=ts"
export * from "./ReplenishmentSimulator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports